
<template>
  <div class="top4">
    <div class="boxtitle">
      <div class="bleft">
        <div class="btitle">
          <span>图书投票区</span>
        </div>
        <span style="color:#666">（按书籍名称首字母排序）</span>
      </div>
      <div class="bright">
        <div class="brm">
          <input type="text"
                 placeholder="请输入书名或主编姓名"
                 v-model="text">
          <img src="../../../assets/img/reading/x.png"
               v-show="text"
               @click="toQing"
               alt="">
        </div>
        <div class="brr"
             @click="toSearch()">
          <img src="../../../assets/img/icon/search.png"
               alt="">
        </div>
      </div>
    </div>
    <el-alert title="投票通道已关闭，感谢您对本活动的支持！后续将进入专家评审阶段，最终结果将以“2022全科医生好书推荐榜单”（不排名）形式进行公布，敬请期待！"
              type="info"
              :closable="false"
              effect="dark">
    </el-alert>
    <div class="t4fbox">
      <div class="t4box"
           v-for="(item, index) in list"
           :style="index%5==0?'margin-left:0':''"
           :key="index">
        <div class="t4bt1">
          <img :src="item.bookCoverUrl"
               :key="item.id"
               alt="" />
        </div>
        <div class="t4bt2">
          <el-popover placement="top-start"
                      width="200"
                      trigger="hover"
                      :content="item.rmdBookName">
            <div slot="reference">{{item.rmdBookName}}</div>
          </el-popover>
        </div>
        <div class="t4bt3">
          <span>总投票数：{{item.voteTotal+item.votebase}}</span>
        </div>
        <div class="t4bt4">
          <!-- <div class="t4bt4l"
               @click="toToupiao(item)">投票</div> -->
          <div class="t4bt4r"
               @click="toJieshao(item)">图书介绍</div>
        </div>
      </div>
      <div class="nobox"
           v-show="list.length==0">未找到相关图书</div>
    </div>
    <el-dialog :visible.sync="isjieshao"
               class="jieshao"
               :before-close="handleClose">
      <img :src="info.bookCoverUrl"
           alt="">
      <div class="jsRight">
        <p>图书：{{info.rmdBookName}}</p>
        <p>主编：{{info.authorName}}</p>
        <p>出版社：{{info.publishUnit}}</p>
        <p>ISBN：{{info.isbn}}</p>
        <p>推荐理由：{{info.rmdReason}}</p>
      </div>
    </el-dialog>
    <div class="t4bot"
         @click="toMore"
         v-show="page.total>list.length&&page.total>page.limit">
      <span>加载更多书籍</span>
      <img src="../../../assets/img/reading/xia.png"
           alt="">
    </div>
    <div class="t4bot"
         @click="toSouqi"
         v-show="page.total==list.length&&page.total>page.limit">
      <span>收起</span>
      <img src="../../../assets/img/reading/xia.png"
           style="transform: rotate(180deg)"
           alt="">
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      text: '',
      stext: '',
      list: [],
      isjieshao: false,
      info: '',
      page: {
        index: 1,
        limit: 15,
        total: 0
      },
      uid: 0
    }
  },
  created () {
    if (localStorage.getItem('ResData')) {
      this.uid = Number(JSON.parse(localStorage.getItem('ResData')).id);
    }
    this.toSearch()
  },
  methods: {
    getNowTime () {
      function addZero (s) {
        return s < 10 ? "0" + s : s;
      }
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return year + "-" + addZero(month) + "-" + addZero(day)
    },
    toSearch () {
      this.page.index = 1
      this.stext = this.text
      this.httphelper
        .post('/api/ReadingFestivalApi/GetReaderRecommendInfoPageList', {
          type: ',1,',
          keyword: this.stext,
          labelgather: '',
          page: this.page.index,
          limit: this.page.limit
        })
        .then(res => {
          if (res.data.code == 200) {
            this.list = res.data.data
            this.page.total = res.data.totalcount
          }
        });
    },
    toQing () {
      this.text = ''
      if (this.stext) {
        this.toSearch()
      }
    },
    toMore () {
      this.page.index++
      this.httphelper
        .post('/api/ReadingFestivalApi/GetReaderRecommendInfoPageList', {
          type: ',1,',
          keyword: this.stext,
          labelgather: '',
          page: this.page.index,
          limit: this.page.limit
        })
        .then(res => {
          if (res.data.code == 200) {
            this.list = this.list.concat(res.data.data)
          }
        });
    },
    toSouqi () {
      this.page.index = 1
      this.list = this.list.slice(0, this.page.limit)
    },
    toToupiao (item) {
      if (this.uid <= 0) {
        this.$alert('请先登录', '提示', {
          confirmButtonText: '确定', callback: action => {
            if (action == 'confirm') {
              let callback = encodeURIComponent(window.location.href);
              this.$router.push({
                path: '/loginIndex/login',
                query: {
                  callback: callback
                }
              })
            }
          }
        });
      } else {
        let date = this.getNowTime()
        this.httphelper
          .post('/api/ReadingFestivalApi/SumbitBookVote', {
            bookId: item.id,
            userid: this.uid,
            date: date,
            voteNumber: 1,
            voteSum: 10
          })
          .then(res => {
            if (res.data.code == 200) {
              item.votebase++
              this.$message({
                message: '投票成功',
                type: 'success'
              });
            } else if (res.data.code == 205) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.error('投票失败');
            }
          });
      }
    },
    toJieshao (item) {
      this.info = item
      this.isjieshao = true
    },
    handleClose () {
      this.info = ''
      this.isjieshao = false
    }
  }
}
</script>
<style lang="scss" scoped>
.top4 {
    width: 1200px;
    margin: 0 auto 30px;
    .boxtitle {
        width: 100%;
        border-bottom: 1px solid #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 20px 0;
        .btitle {
            display: inline-block;
            font-size: 26px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #000000;
            line-height: 26px;
            padding: 15px 0;
            border-bottom: 1px solid #000;
        }
        .bright {
            width: 350px;
            height: 36px;
            background: #ffffff;
            border: 1px solid #007380;
            border-radius: 18px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-sizing: border-box;
            position: relative;
            .brl {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #000000;
                line-height: 16px;
                margin: 0 10px 0 15px;
                cursor: pointer;
                width: 71px;
                img {
                    margin-left: 5px;
                }
                span {
                    width: 56px;
                    text-align: center;
                }
            }
            .brm {
                height: 26px;
                width: 280px;
                padding-left: 14px;
                display: flex;
                align-items: center;
                input {
                    height: 26px;
                    flex: 1;
                    border: none;
                    font-size: 15px;
                }
                img {
                    width: 18px;
                    height: 18px;
                    margin: 9px;
                    cursor: pointer;
                }
            }
            .brr {
                width: 54px;
                height: 36px;
                background: #007380;
                border-radius: 0px 18px 18px 0px;
                cursor: pointer;
                overflow: hidden;
                img {
                    margin-left: 5px;
                }
            }
            .brzm {
                position: absolute;
                width: 350px;
                height: 100px;
                background: #ffffff;
                border: 1px solid #007380;
                border-radius: 18px;
                top: 40px;
                box-sizing: border-box;
                display: flex;
                flex-wrap: wrap;
                padding: 6px 7px;
                .zm {
                    width: 37px;
                    text-align: center;
                    line-height: 28px;
                    font-size: 14px;
                    cursor: pointer;
                }
            }
        }
    }
    ::v-deep .el-alert__title {
        font-size: 16px;
        line-height: 30px;
    }
    .t4fbox {
        width: 1200px;
        display: flex;
        flex-wrap: wrap;
        margin-top: 30px;
    }
    .t4box {
        width: 216px;
        height: 407px;
        // height: 365px;
        border-radius: 5px;
        margin-bottom: 20px;
        margin-left: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .t4bt1 {
            width: 157px;
            height: 210px;
            background: #ffffff;
            box-shadow: 8px 6px 15px 0px rgba(0, 0, 0, 0.15);
            margin-top: 10px;
            margin-bottom: 5px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .t4bt2 {
            height: 52px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
            line-height: 26px;
            margin: 15px 20px;
            display: -webkit-box;
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
        .t4bt3 {
            width: 170px;
            height: 32px;
            background: #f5f7fa;
            border-radius: 3px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
            line-height: 32px;
            text-align: center;
            margin-bottom: 10px;
        }
        .t4bt4 {
            width: 170px;
            display: flex;
            justify-content: space-between;
            text-align: center;
            line-height: 28px;
            .t4bt4l {
                width: 65px;
                height: 30px;
                background: #fcf6f6;
                border: 1px solid #d7000b;
                border-radius: 3px;
                box-sizing: border-box;
                color: #d7000b;
                cursor: pointer;
            }
            .t4bt4r {
                width: 170px;
                height: 30px;
                background: #def3f3;
                border: 1px solid #0b8586;
                color: #0b8586;
                border-radius: 3px;
                box-sizing: border-box;
                cursor: pointer;
            }
        }
    }
    .t4box:hover {
        box-shadow: 6px 17px 23px 0px rgba(11, 133, 134, 0.25);
        border-radius: 5px;
        .t4bt4l {
            background: #d7000b;
            color: #fff;
        }
        .t4bt4r {
            background: #0b8586;
            color: #fff;
        }
    }
    .nobox {
        width: 100%;
        line-height: 100px;
        text-align: center;
    }
    .jieshao {
        ::v-deep .el-dialog {
            width: 600px;
            border-radius: 5px;
        }
        ::v-deep .el-dialog__header {
            padding: 0;
        }
        ::v-deep .el-dialog__body {
            padding: 45px 35px 50px;
            display: flex;
            img {
                width: 154px;
                height: 221px;
                box-shadow: 12px 9px 15px 0px rgba(0, 0, 0, 0.22);
                margin-right: 30px;
                margin-top: 5px;
            }
            .jsRight {
                display: flex;
                flex-direction: column;
                line-height: 22px;
                p {
                    margin: 5px 0;
                }
            }
        }
    }
    .t4bot {
        width: 350px;
        height: 40px;
        background: #0b8586;
        border-radius: 20px;
        margin: 10px auto;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        img {
            margin-left: 10px;
        }
    }
}
</style>